import classes from "./Footer.module.css";

function Footer() {
	return (
		<footer className={classes.main}>
			<p className={classes.copyright}>&copy; Copyright DC WEARS.</p>
		</footer>
	);
}
export default Footer;
